<template>
  <div class="container mt-2">
    <!-- Seccion de Subidas a Fidu -->
    <div class="mb-2 d-flex flex-column gap-2 justify-content-start">
      <div class="d-flex flex-row gap-2 align-items-center justify-content-between">
        <div class="d-flex flex-row gap-2 align-items-center">
          <p class="m-0 fs-4 w-100">{{ $t('subidasFidu') }}</p>

          <div v-if="hasVerTodasSubidasFidu" class="select-wrapper" style="width: 150px;">
            <select v-model="deQuien" class="form-select w-100 fs-8 borde-terciario sombra-sm texto-principal" style="max-width: 100px; height: 40px;" @change="fetchSubidasFidu(currentPageSubidas, deQuien)">
              <option value="mias">
                {{ $t('mias') }}
              </option>
              <option value="todas">
                {{ $t('todas') }}
              </option>
            </select>
            <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
        </div>

        
        <button v-if="hasSubirDocFidu" @click="showModal = true" class="btn bg-goethe-accent p-1 rounded sombra-sm">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div v-for="(subida) in SubidasFidu" :key="subida.IdSubidasFidu" class="d-flex flex-column gap-2 w-100 border-0 sombra-sm fondo-secundario rounded-3">
        <div class="d-flex flex-row w-100 p-2 px-3 border border-0 fondo-terciario justify-content-between sombra-sm rounded-3 align-items-center" style="cursor: pointer;" @click="subida.showValues = !subida.showValues; fetchDetalle(subida.IdSubidasFidu, 1)">
          <div class="d-flex flex-column justify-content-between mb-1">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row align-items-center">
                <p class="fs-5 m-0 text-start">{{subida.TituloDocumento}}</p>
                <p class="fs-5 m-0 text-start ms-2">•</p>
                <a :href="`https://drive.google.com/drive/folders/${subida.FolderId}`"
                  class="d-flex flex-row text-decoration-none align-items-center justify-content-start home-list p-1 px-2 rounded-5" target="_blank">
                  <svg width="15" height="15" viewBox="0 0 800 742" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="a" width="168" height="154" x="12" y="18" maskUnits="userSpaceOnUse">
                      <path fill="#fff" d="M63.09 37c14.626-25.333 51.193-25.334 65.819 0l45.033 78c14.626 25.334-3.657 57.001-32.91 57.001H50.967c-29.253 0-47.536-31.667-32.91-57.001Z"/>
                    </mask>
                    <g mask="url(#a)" transform="matrix(4.8140532,0,0,4.8140532,-62.146701,-86.652356)">
                      <path fill="url(#b)" d="M206.905 172.02h-91.888l-19.015-32.934 45.944-79.578Z"/>
                      <path fill="url(#c)" d="M-14.919 172.006 50.04 59.494v.002L31.032 92.422h38.02L115 172.004l-129.918.001Z"/>
                      <path fill="url(#d)" d="M96.007-20.085 141.954 59.5l-19.011 32.928H31.048Z"/>
                    </g>
                    <defs>
                      <linearGradient id="b" x1="193.6" x2="103.09" y1="165.6" y2="111.21" gradientUnits="userSpaceOnUse">
                        <stop offset=".09" stop-color="#ffe921"/>
                        <stop offset="1" stop-color="#fec700"/>
                      </linearGradient>
                      <linearGradient id="c" x1="114.4" x2="15.53" y1="181.61" y2="121.8" gradientUnits="userSpaceOnUse">
                        <stop offset=".15" stop-color="#a9a8ff"/>
                        <stop offset=".33" stop-color="#6d97ff"/>
                        <stop offset=".48" stop-color="#3186ff"/>
                      </linearGradient>
                      <linearGradient id="d" x1="128.88" x2="28.7" y1="37.88" y2="84.64" gradientUnits="userSpaceOnUse">
                        <stop offset=".55" stop-color="#0ebc5f"/>
                        <stop offset=".85" stop-color="#78c9ff"/>
                      </linearGradient>
                    </defs>
                  </svg>
                  <p class="m-0 fs-7 texto-secundario">{{ $t('verCarpeta')}}</p>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario ms-1" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="d-flex flex-row gap-1 align-items-center">
                <svg v-if="subida.TipoDocumento == 'Facturas'" width="15" height="15" viewBox="0 0 24 24" class="fill-secundario" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.55281 1.60553C7.10941 1.32725 7.77344 1 9 1C10.2265 1 10.8906 1.32722 11.4472 1.6055L11.4631 1.61347C11.8987 1.83131 12.2359 1.99991 13 1.99993C14.2371 1.99998 14.9698 1.53871 15.2141 1.35512C15.5944 1.06932 16.0437 1.09342 16.3539 1.2369C16.6681 1.38223 17 1.72899 17 2.24148L17 13H20C21.6562 13 23 14.3415 23 15.999V19C23 19.925 22.7659 20.6852 22.3633 21.2891C21.9649 21.8867 21.4408 22.2726 20.9472 22.5194C20.4575 22.7643 19.9799 22.8817 19.6331 22.9395C19.4249 22.9742 19.2116 23.0004 19 23H5C4.07502 23 3.3148 22.7659 2.71092 22.3633C2.11331 21.9649 1.72739 21.4408 1.48057 20.9472C1.23572 20.4575 1.11827 19.9799 1.06048 19.6332C1.03119 19.4574 1.01616 19.3088 1.0084 19.2002C1.00194 19.1097 1.00003 19.0561 1 19V2.24146C1 1.72899 1.33184 1.38223 1.64606 1.2369C1.95628 1.09341 2.40561 1.06931 2.78589 1.35509C3.03019 1.53868 3.76289 1.99993 5 1.99993C5.76415 1.99993 6.10128 1.83134 6.53688 1.6135L6.55281 1.60553ZM3.00332 19L3 3.68371C3.54018 3.86577 4.20732 3.99993 5 3.99993C6.22656 3.99993 6.89059 3.67269 7.44719 3.39441L7.46312 3.38644C7.89872 3.1686 8.23585 3 9 3C9.76417 3 10.1013 3.16859 10.5369 3.38643L10.5528 3.39439C11.1094 3.67266 11.7734 3.9999 13 3.99993C13.7927 3.99996 14.4598 3.86581 15 3.68373V19C15 19.783 15.1678 20.448 15.4635 21H5C4.42498 21 4.0602 20.8591 3.82033 20.6992C3.57419 20.5351 3.39761 20.3092 3.26943 20.0528C3.13928 19.7925 3.06923 19.5201 3.03327 19.3044C3.01637 19.2029 3.00612 19.1024 3.00332 19ZM19.3044 20.9667C19.5201 20.9308 19.7925 20.8607 20.0528 20.7306C20.3092 20.6024 20.5351 20.4258 20.6992 20.1797C20.8591 19.9398 21 19.575 21 19V15.999C21 15.4474 20.5529 15 20 15H17L17 19C17 19.575 17.1409 19.9398 17.3008 20.1797C17.4649 20.4258 17.6908 20.6024 17.9472 20.7306C18.2075 20.8607 18.4799 20.9308 18.6957 20.9667C18.8012 20.9843 18.8869 20.9927 18.9423 20.9967C19.0629 21.0053 19.1857 20.9865 19.3044 20.9667Z"/>
                  <path d="M5 8C5 7.44772 5.44772 7 6 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H6C5.44772 9 5 8.55229 5 8Z"/>
                  <path d="M5 12C5 11.4477 5.44772 11 6 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12Z"/>
                  <path d="M5 16C5 15.4477 5.44772 15 6 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H6C5.44772 17 5 16.5523 5 16Z"/>
                </svg>
                <svg v-if="subida.TipoDocumento == 'Boletines'" class="fill-secundario" width="15" height="15" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  enable-background="new 0 0 1000 1000" xml:space="preserve">                 
                  <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
                    <path d="M1685.8,4989.2c-253.7-58.9-499.3-265.9-621.1-519.6l-75.1-158.3l-6.1-4141c-4.1-2772.8,2-4173.4,16.2-4238.4c56.8-267.9,257.8-513.6,523.7-639.4l156.3-75.1l3258-6.1c2174-4.1,3290.4,2,3355.4,16.2c326.8,69,627.2,365.4,702.4,692.2c14.2,58.9,22.3,1049.5,22.3,2809.4c0,2616.5-2,2724.1-38.6,2801.2c-48.7,101.5-3373.6,3428.5-3458.9,3460.9C5449.2,5017.6,1797.5,5015.6,1685.8,4989.2z M4856.5,3087.2c0-1433.1,2-1451.4,115.7-1648.3c89.3-152.2,253.7-298.4,426.3-381.6l158.3-75.1l1427-6.1l1425-6.1v-2494.7c0-1891.9-6.1-2506.9-24.4-2547.5c-52.8-117.7,148.2-111.6-3385.8-111.6s-3333.1-6.1-3385.8,111.6c-38.6,81.2-34.5,8302.2,4.1,8371.2c58.9,105.6,12.2,101.5,1682.8,103.5h1556.9V3087.2z M6866.1,1585.1c-1351.9-4.1-1337.7-6.1-1380.3,109.6c-12.2,30.5-20.3,552.1-20.3,1293V4230l1319.4-1319.4l1319.4-1319.4L6866.1,1585.1z"/>
                    <path d="M2989-327.1v-304.5h2009.6h2009.6v304.5v304.5H4998.6H2989V-327.1z"/>
                    <path d="M2989-1646.5V-1951h2009.6h2009.6v304.5v304.5H4998.6H2989V-1646.5z"/>
                    <path d="M2989-2925.3v-304.5h954.1h954v304.5v304.5h-954H2989V-2925.3z"/>
                  </g>
                </svg>
                
                <svg v-if="subida.TipoDocumento == 'Informes'" class="fill-secundario" fill="none" width="15" height="15" viewBox="2 2 28 28" id="icon" xmlns="http://www.w3.org/2000/svg">
                  <rect x="10" y="18" width="8" height="2"/>
                  <rect x="10" y="13" width="12" height="2"/>
                  <rect x="10" y="23" width="5" height="2"/>
                  <path d="M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"/>
                </svg>
                <p class="fs-7 m-0 texto-secundario text-start">{{ $t(subida.TipoDocumento ?? '')}} - {{ new Date(new Date(subida.FechaDocumento)).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false, // Para usar el formato de 24 horas
                  }).slice(0, 10)}}</p>
              </div>
            </div>
            
            <div class="d-flex flex-row gap-2 align-items-center mt-2">
              <div class="d-flex align-items-center justify-content-center p-0">
                <img v-if="subida.IdPersonaNavigation?.FotoUrl" :src="subida.IdPersonaNavigation?.FotoUrl" alt="Profile Picture" class="img-responsive" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover;" />
                <div v-else alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive fondo-gris mx-auto" style="width: 20px; height: 20px; border-radius: 50%; object-fit: cover; padding: 2px;" >
                  <i class="bi bi-person-fill texto-principal fs-8"></i>
                </div>
              </div>
              <p class="fs-8 m-0 d-none d-md-block texto-secundario text-start">{{ subida.IdPersonaNavigation?.Apellido + " " + subida.IdPersonaNavigation?.Nombre}} - {{new Date(new Date(subida.FechaHoraSubida)).toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false, // Para usar el formato de 24 horas
                })}}</p>
            </div>
          </div>
          <div class="d-flex gap-2 align-items-center">
            <div v-if="hasEliminarDocFidu && subida.CantDocsSubidos > 0" class="m-0">
              <button class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0 m-0" @click.stop="isDeleteConfirmVisibleMasivo = true; documentIdToDelete = subida.IdSubidasFidu; documentNameToDelete = subida.TituloDocumento">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <div v-if="subida.CantPendientes > 0 && 
           Date.now() >= (Date.parse(subida.FechaHoraSubida) + 86400000) && 
           Date.now() <= (Date.parse(subida.FechaHoraSubida) + 172800000)" 
     class="m-0">
              <button class="btn p-1 px-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0 m-0 fondo-gris" @click.stop="cancelSubida(subida.IdSubidasFidu)">
                {{ $t('cancelarSubida') }}
              </button>
            </div>
            <div v-if="loadingCancelSubmit" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <div class="d-flex flex-column align-items-end justify-content-center gap-1">
              <div v-if="subida.CantPendientes >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-nada-2" style="height: 22px;">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('pendiente') }} {{ subida.CantPendientes }}</p>
              </div>
              <div v-if="subida.CantCancelados >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-nada-2" style="height: 22px;">
                <svg width="14" height="14" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="9" stroke-width="2"/>
                  <path d="M18 18L6 6" stroke-width="2"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('cancelado') }} {{ subida.CantCancelados }}</p>
              </div>
              <div v-if="subida.CantDocsSubidos >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-aprobado-2" style="height: 22px;">
                <svg width="14" height="14" viewBox="0 1 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M20.6097 5.20743C21.0475 5.54416 21.1294 6.17201 20.7926 6.60976L10.7926 19.6098C10.6172 19.8378 10.352 19.9793 10.0648 19.9979C9.77765 20.0166 9.49637 19.9106 9.29289 19.7072L4.29289 14.7072C3.90237 14.3166 3.90237 13.6835 4.29289 13.2929C4.68342 12.9024 5.31658 12.9024 5.70711 13.2929L9.90178 17.4876L19.2074 5.39034C19.5441 4.95258 20.172 4.87069 20.6097 5.20743Z"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('subido') }} {{ subida.CantDocsSubidos }}</p>
              </div>
              
              <div v-if="subida.CantAlertas >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-semiaprobado-2" style="height: 22px;">
                <svg width="14" height="14" class="stroke-principal" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15H12.01M12 12V9M4.98207 19H19.0179C20.5615 19 21.5233 17.3256 20.7455 15.9923L13.7276 3.96153C12.9558 2.63852 11.0442 2.63852 10.2724 3.96153L3.25452 15.9923C2.47675 17.3256 3.43849 19 4.98207 19Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('alerta') }} {{ subida.CantAlertas }}</p>
              </div>
              <div v-if="subida.CantErrores >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-desaprobado-2" style="height: 22px;">
                <svg class="mx-1 fill-principal" height="10" width="10" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                  viewBox="0 0 47.095 47.095" xml:space="preserve">
                  <path d="M45.363,36.234l-13.158-13.16l12.21-12.21c2.31-2.307,2.31-6.049,0-8.358c-2.308-2.308-6.05-2.307-8.356,0l-12.212,12.21
                    L11.038,1.906c-2.309-2.308-6.051-2.308-8.358,0c-2.307,2.309-2.307,6.049,0,8.358l12.81,12.81L1.732,36.831
                    c-2.309,2.31-2.309,6.05,0,8.359c2.308,2.307,6.049,2.307,8.356,0l13.759-13.758l13.16,13.16c2.308,2.308,6.049,2.308,8.356,0
                    C47.673,42.282,47.672,38.54,45.363,36.234z"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('error') }} {{ subida.CantErrores }}</p>
              </div>
              <div v-if="subida.CantEliminados >= 1" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-2.5 text-decoration-none select-desaprobado-2" style="height: 22px;">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="fs-8 m-0 ms-1">{{ $t('eliminado') }} {{ subida.CantEliminados }}</p>
              </div>
            </div>
            <svg width="20px" height="20px" class="m-3 me-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: subida.showValues ? 'scaleY(1)' : 'scaleY(-1)' }">
              <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
            </svg>
          </div>
        </div>
        <div v-if="subida.showValues">
          <div class="px-2">
            <div class="d-flex align-items-center position-relative w-100 mb-2">
              <input type="text" class="form-control m-0 sombra-sm" style="height: 40px;" :placeholder="$t('buscarPorNombre') + '...'" v-model="searchTermDetalle" @keyup.enter="fetchDetalle(subida.IdSubidasFidu, 1)" @input="filterDetalle(subida.IdSubidasFidu)"/>
              <button v-if="searchTermDetalle" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="searchTermDetalle = ''; fetchDetalle(subida.IdSubidasFidu, 1)">
                <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
              </button>
            </div>
          </div>
          <div class="overflow-y-auto" style="max-height: 450px;" @scroll="handleScroll($event, subida.IdSubidasFidu)">
            <div v-for="(subidaDetalle, indexDetalle) in subida.SubidasFiduDetalles" :key="subidaDetalle.IdSubidasFiduDetalle" class="d-flex flex-row align-items-center justify-content-between p-2 px-3 border-0">
              <div class="d-flex flex-column">
                <div class="d-flex flex-row gap-2 align-items-center">
                  <p class="fs-6 m-0 text-start">{{(indexDetalle + 1) + ". " + subidaDetalle.NombreUsuario}}</p>
                  <a v-if="subidaDetalle.DocId" href="javascript:void(0)" @click.prevent="verDocumento(subidaDetalle)"
                    class="d-flex flex-row text-decoration-none align-items-center justify-content-start gap-1 home-list p-1 px-2 rounded-5" target="_blank">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p class="m-0 fs-7 texto-secundario">{{ $t('verDocumento')}}</p>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
                      <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                  <div v-if="subidaDetalle.loadingDocSubida" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                    <img src="../../assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
                  </div>
                </div>
                <p class="fs-6 m-0 text-start">{{ subidaDetalle.NombreDocSubido}}</p>
                <div class="d-flex fs-7 m-0 texto-principal text-start gap-1">
                  <div  class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 text-decoration-none"
                    :class="{ 'select-aprobado': subidaDetalle.Estado === 'Subido',
                              'select-desaprobado': subidaDetalle.Estado === 'Error' || subidaDetalle.Estado === 'Eliminado',
                              'select-semiaprobado-2': subidaDetalle.Estado === 'Alerta',
                              'select-nada': subidaDetalle.Estado === 'Cancelado'}" style="height: 22px;">
                    <span class="fs-7 texto-principal">{{ $t(subidaDetalle.Estado?.toLowerCase() ?? '') }}</span>
                  </div>
                  <span v-if="subidaDetalle.ErrorDescr != null && subidaDetalle.ErrorDescr != ''">{{ subidaDetalle.ErrorDescr}}</span>
                  <p v-if="subidaDetalle.FechaHoraRegistro" class="fs-8 m-0 d-none d-md-inline-block texto-secundario text-start">{{new Date(new Date(subidaDetalle.FechaHoraRegistro)).toLocaleDateString('es-ES', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      hour12: false, // Para usar el formato de 24 horas
                    })}}</p>
                </div>
              </div>
              <div v-if="(hasEliminarDocFidu || hasEliminarDocFiduSubidosPorUsuario) && subidaDetalle.Estado == 'Subido'" class="m-0">
                <button class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0 m-0" @click="isDeleteConfirmVisible = true; documentIdToDelete = subidaDetalle.DocId; documentNameToDelete = subida.TituloDocumento; documentUserNameToDelete = subidaDetalle.NombreUsuario">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                    <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            <div v-if="loadingSubidasDetalle" class="loading-spinner ms-3 d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <br v-if="subida?.SubidasFiduDetalles?.length >= 10">
          </div>
        </div>
      </div>
      
      <!-- Controles de Paginación Subidas --> 
      <nav aria-label="Page navigation" class="d-flex flex-row mb-2">
        <ul class="pagination m-0 sombra">
          <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end" :class="{ disabled: currentPageSubidas === 1 }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="fetchSubidasFidu(currentPageSubidas - 1, deQuien)">{{ $t('anterior') }}</a>
          </li>
          <li class="p-2 bg-goethe-accent-claro-3 borde-secundario">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPageSubidas }} {{$t('de')}} {{ totalPagesSubidas }}</a>
          </li>
          <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start" :class="{ disabled: currentPageSubidas === totalPagesSubidas }">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="fetchSubidasFidu(currentPageSubidas + 1, deQuien)">{{ $t('siguiente') }}</a>
          </li>
        </ul>
        <div v-if="loadingSubidas" class="loading-spinner ms-3 d-flex flex-row align-items-center justify-content-center">
          <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </nav>
    </div>

    <!-- Modal subir documentos a Fidu -->
    <div v-if="showModal & hasSubirDocFidu" class="modal-overlay">
      <div class="modal-container fondo-secundario sombra texto-principal">
        <h3>{{$t('subirDocsGoetheApp')}}</h3>
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="titulo" class="form-label">{{$t('tituloDocumento')}}</label>
            <input type="text" id="titulo" v-model="newSubida.TituloDocumento" class="form-control sombra-sm" required />
          </div>
          <label for="tipoDoc" class="form-label">{{$t('cicloLectivo')}}</label>
          <select v-model="newSubida.CicloLectivo" class="form-select w-100 fs-8 borde-terciario sombra-sm texto-principal mb-3" style="max-width: 100px; height: 40px;" @change="expandedUserId = ''">
            <option v-for="CicloLectivo in Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, i) => 2024 + i)" 
                    :key="CicloLectivo" 
                    :value="CicloLectivo">
              {{ CicloLectivo }}
            </option>
          </select>
          <label for="tipoDoc" class="form-label">{{$t('tipoDocumento')}}</label>
          <div class="select-wrapper w-100 mb-3">
            <select v-model="newSubida.TipoDocumento" class="form-select w-100 fs-6 borde-terciario sombra-sm" style="height: 38px;">
              <option v-if="tipoDocsFromPermissions.some( pn => pn == 'Boletines')" value="Boletines">1-{{$t('Boletines')}}</option>
              <option v-if="tipoDocsFromPermissions.some( pn => pn == 'Informes')" value="Informes">2-{{$t('Informes')}}</option>
              <option v-if="tipoDocsFromPermissions.some( pn => pn == 'Facturas')" value="Facturas">3-{{$t('Facturas')}}</option>
            </select>
            <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
          <!-- Campo para subir archivo -->
          <div class="mb-3">
            <label for="FolderID" class="form-label">{{$t('urlCarpeta')}}</label>
            <input type="text" id="FolderID" v-model="newSubida.FolderID" :placeholder="$t('pegaLinkDrive')" class="form-control sombra-sm" required />
          </div>
          <div class="mb-3">
            <label for="fecha" class="form-label">{{$t('fechaDocumento')}}</label>
            <input type="date" id="fecha" v-model="newSubida.FechaDocumento" class="form-control sombra-sm" required />
          </div>
          
          <div class="d-flex flex-row gap-2">
            <button type="submit" class="btn btn-primary sombra-sm" :disabled="loadingSubmit">{{$t('subirDocumentos')}}</button>
            <button @click="showModal = false" type="button" class="btn btn-secondary sombra-sm" :disabled="loadingSubmit">{{$t('cerrar')}}</button>
            <div v-if="loadingSubmit" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Modal de confirmación -->
    <template v-if="isDeleteConfirmVisible">
      <div class="modal-overlay" @click="isDeleteConfirmVisible = false">
        <div class="modal-content" @click.stop>
          <p>{{$t('seguroEliminarDoc')}}</p>
          <p>"{{ documentNameToDelete }}" {{ $t('delAlumno') }}: {{ documentUserNameToDelete }}</p>
          <div class="d-flex flex-row gap-2 w-100">
            <button class="btn btn-danger w-100" @click="deleteDoc">{{ $t('Si') }}</button>
            <div v-if="loadingDeleteDocuments" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <button class="btn btn-secondary w-100" @click="isDeleteConfirmVisible = false">{{ $t('No') }}</button>
          </div>
        </div>
      </div>
    </template>
    <!-- Modal de confirmación Masivo -->
    <template v-if="isDeleteConfirmVisibleMasivo">
      <div class="modal-overlay" @click="isDeleteConfirmVisibleMasivo = false">
        <div class="modal-content" @click.stop>
          <p>{{$t('seguroEliminarDocMasivo')}}</p>
          <p>"{{ documentNameToDelete }}"</p>
          <div class="d-flex flex-row gap-2 w-100">
            <button class="btn btn-danger w-100" @click="deleteDocMasivo">{{ $t('Si') }}</button>
            <div v-if="loadingDeleteDocuments" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <button class="btn btn-secondary w-100" @click="isDeleteConfirmVisibleMasivo = false">{{ $t('No') }}</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, computed, reactive } from 'vue';
import { API_BASE_URL } from '../../config';
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';
import * as signalR from '@microsoft/signalr';
import api from '@/services/api';

export default {
  name: 'SubidasFidu',
  setup() {
    const { t } = useI18n();
    const users = ref([]);
    const SubidasFidu = ref([]);
    const documents = ref([]);
    const searchTermDetalle = ref('');
    let deQuien = ref('mias');
    let currentPageSubidas = ref(1);
    let itemsPerPageSubidas = ref(5);
    let totalPagesSubidas = ref(1);
    let currentPageSubidasDetalle = ref(1);
    let itemsPerPageSubidasDetalle = ref(5);
    let totalPagesSubidasDetalle = ref(1);
    const expandedUserId = ref(''); // ID del usuario expandido
    var loadingSubidas = ref(false);
    var loadingSubidasDetalle = ref(false);
    var loadingSubmit = ref(false);
    var loadingCancelSubmit = ref(false);
    var loadingDocuments = ref(false);
    var loadingDeleteDocuments = ref(false);
    var isDeleteConfirmVisible = ref(false);
    var isDeleteConfirmVisibleMasivo = ref(false);
    var documentIdToDelete = ref('');
    var documentNameToDelete = ref('');
    var documentUserNameToDelete = ref('');
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const errors = reactive({
      Roles: '',
      Permisos: '',
    });
    const hasEliminarDocFidu = ref(false);
    const hasEliminarDocFiduSubidosPorUsuario = ref(false);
    const hasSubirDocFidu = ref(false);
    const hasVerTodasSubidasFidu = ref(false);
    const showModal = ref(false);
    const newSubida = ref({
      TituloDocumento: "",
      TipoDocumento: "",
      FolderID: "",
      FechaDocumento: "",
      CicloLectivo: new Date().getFullYear(),
    });
    let connection;
    let timeoutId = null;
    const tipoDocsFromPermissions = ref([])

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var categoriaAComprobar = 'VerAlumnosFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.subCategoria === categoriaAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.subCategoria === categoriaAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        
        var permisoAComprobar = 'EliminarDocFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasEliminarDocFidu.value = true;
        }
        
        permisoAComprobar = 'EliminarDocFiduSubidosPorUsuario'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasEliminarDocFiduSubidosPorUsuario.value = true;
        }
        
        permisoAComprobar = 'SubirDocFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasSubirDocFidu.value = true;
        }
        
        permisoAComprobar = 'VerTodasSubidasFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasVerTodasSubidasFidu.value = true;
        }
      }
    };

    const filterDetalle = (subidaId) => {
      // Limpia el temporizador anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Establece un nuevo temporizador
      timeoutId = setTimeout(() => {
        // Llama a fetchUsers después de 500ms (0.5 segundos) de inactividad
        fetchDetalle(subidaId, 1);
      }, 1000); // Puedes ajustar este valor a tu gusto (en milisegundos)
    };


    const fetchSubidasFidu = async (page, deQuien) => {
      try {
        loadingSubidas.value = true
        if(page <= totalPagesSubidas.value && page >= 1){
          let response;
          if(deQuien == 'todas'){
            response = await api.get(`api/FiduSubidas/All`, {
              params:{
                page: page,
              },
            });
          }
          else{
            response = await api.get(`api/FiduSubidas`, {
              params:{
                idUsuario: user?.value.idPersona,
                page: page,
              },
            });
          }
          console.log("fetchSubidasFidu")
          console.log(response.data)
          SubidasFidu.value = response.data;
          
          currentPageSubidas.value = parseInt(response.headers['x-pagination-current-page']) || 1;
          itemsPerPageSubidas.value = parseInt(response.headers['x-pagination-per-page']) || 5;
          totalPagesSubidas.value = parseInt(response.headers['x-pagination-total-pages']) || 0;
        }
        console.log("fetchSubidasFidu2")
        console.log(SubidasFidu.value)
        loadingSubidas.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loadingSubidas.value = false
      }
    };

    const handleScroll = (event, idSubida) => {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      
      // Si falta menos de 5px para llegar al fondo y no estamos cargando
      if (scrollHeight - scrollTop <= clientHeight + 5 && !loadingSubidasDetalle.value) {
        if (currentPageSubidasDetalle.value < totalPagesSubidasDetalle.value) {
          fetchDetalle(idSubida, currentPageSubidasDetalle.value + 1);
        }
      }
    };

    const fetchDetalle = async (idSubida, page) => {
      try {
        loadingSubidasDetalle.value = true
        if(page <= totalPagesSubidasDetalle.value && page >= 1){
          const response = await api.get(`api/FiduSubidas/Detalles`, {
            params:{
              subidaId: idSubida,
              searchTerm: searchTermDetalle.value,
              page: page,
            },
          });
          console.log("fetchDetalle")
          console.log(response.data)
          const subidaPrincipal = SubidasFidu.value.find(s => s.IdSubidasFidu === idSubida);
    
          if (subidaPrincipal) {
            // SI es la página 1, reemplazamos. SI es > 1, concatenamos.
            if (page === 1) {
              subidaPrincipal.SubidasFiduDetalles = response.data;
            } else {
              subidaPrincipal.SubidasFiduDetalles.push(...response.data);
            }
          }
          
          currentPageSubidasDetalle.value = parseInt(response.headers['x-pagination-current-page']) || 1;
          itemsPerPageSubidasDetalle.value = parseInt(response.headers['x-pagination-per-page']) || 10;
          totalPagesSubidasDetalle.value = parseInt(response.headers['x-pagination-total-pages']) || 1;
        }
        loadingSubidasDetalle.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loadingSubidasDetalle.value = false
      }
    };

    const verDocumento = async (subida) => {
        try {
        subida.loadingDocSubida = true;
        // Definimos el año (puedes pasarlo por parámetro o usar una ref del sistema)
        const anio = 2026; 
        
        // 1. Buscamos el documento con el ID y el año
        // Nota: El token ya debería estar configurado en los interceptores de tu instancia 'api'
        const response = await api.get(`api/FiduDocumentos/${subida.DocId}`, {
          params: {
            año: anio
          }
        });

        // 2. Extraemos el link de la propiedad 'file' 
        // (Ajusta 'response.data.file' según la estructura exacta de tu JSON)
        const urlDocumento = response.data.file;

        if (urlDocumento) {
          // 3. Redirigimos en una nueva pestaña
          window.open(urlDocumento, '_blank');
        } else {
          console.error("No se encontró el link del archivo en la respuesta.");
          // Aquí podrías mostrar una notificación de error al usuario
        }
        subida.loadingDocSubida = false;
      } catch (error) {
        subida.loadingDocSubida = false;
        console.error("Error al intentar ver el documento:", error);
        // Manejo de errores (ej: 404 o 401)
      }
    };

    const submitForm = async () => {
      try {
        loadingSubmit.value = true
        
        // --- CHEQUEO Y CONEXIÓN ANTES DE SUBIR ---
        try {
          await ensureSignalRConnection();
        } catch (connectionError) {
          alert(connectionError.message);
          loadingSubmit.value = false;
          return; // Frenamos el submit si SignalR está caído por completo
        }

        // Validación del link de Drive
        const regex = /\/folders\/([a-zA-Z0-9_-]+)/
        const match = newSubida.value.FolderID.match(regex)

        if (match && match[1]) {
          newSubida.value.FolderID = match[1]
        } else {
          newSubida.value.FolderID = ''
          alert('El link no parece válido. Asegurate de pegar un enlace de carpeta de Drive.')
          return
        }

        newSubida.value.IdPersona = user?.value.idPersona
        await api.post(`api/FiduSubidas/SubirArchivos`, newSubida.value);
        console.log('Subida agregada');

        
        newSubida.value = {
          TituloDocumento: "",
          TipoDocumento: "",
          FolderID: "",
          FechaDocumento: "",
          CicloLectivo: new Date().getFullYear(),
        };
        showModal.value = false
        loadingSubmit.value = true
      } catch (error) {
        loadingSubmit.value = true
        console.error('Error al agregar la galería:', error);
      }
    };

    const cancelSubida = async (idSubida) => {
      try {
        loadingCancelSubmit.value = true
        
        // --- CHEQUEO Y CONEXIÓN ANTES DE SUBIR ---
        try {
          await ensureSignalRConnection();
        } catch (connectionError) {
          alert(connectionError.message);
          loadingCancelSubmit.value = false;
          return; // Frenamos el cancel si SignalR está caído por completo
        }

        await api.post(`api/FiduSubidas/Cancelar/`+idSubida);
        console.log('Subida cancelada');

        loadingCancelSubmit.value = false
      } catch (error) {
        loadingCancelSubmit.value = false
        console.error('Error al agregar la galería:', error);
      }
    };

    const deleteDoc = async () => {
      try {
        loadingDeleteDocuments.value = true;
        console.log(documentIdToDelete.value)
        await api.delete(`api/FiduDocumentos`,  {
          params: {
            docId: documentIdToDelete.value
          }
        });
        isDeleteConfirmVisible.value = false;
        documentIdToDelete.value = '';
        documentNameToDelete.value = '';
        documentUserNameToDelete.value = '';
        loadingDeleteDocuments.value = false;
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const deleteDocMasivo = async () => {
      try {
        loadingDeleteDocuments.value = true;
        console.log(documentIdToDelete.value)
        await api.delete(`api/FiduDocumentos/Masivo`,  {
          params: {
            subidaId: documentIdToDelete.value
          }
        });
        isDeleteConfirmVisibleMasivo.value = false;
        documentIdToDelete.value = '';
        documentNameToDelete.value = '';
        documentUserNameToDelete.value = '';
        loadingDeleteDocuments.value = false;

        fetchSubidasFidu(currentPageSubidas.value); // Refresca la lista de subidas para reflejar los cambios
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const getDocumentTypesFromPermissions = () => {
      const allowedDocTypes = [];

      const checkAndExtract = (permissionName) => {
        // Regular expression to extract the text between "Ver" and "Fidu"
        const match = permissionName.match(/Ver(.*)Fidu/);
        if (match && match[1]) {
          return match[1]; // The captured group is the part we need
        }
        return null;
      };

      const possiblePermissions = [
        'VerBoletinesFidu',
        'VerInformesFidu',
        'VerFacturasFidu'
      ];

      possiblePermissions.forEach(permisoAComprobar => {
        const hasPermission = user.value.personasPermisos.some(persPermiso =>
          persPermiso.idPermisoNavigation?.permiso === permisoAComprobar
        ) || user.value.personasRoles.some(persRoles =>
          persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)
        );

        if (hasPermission) {
          const extractedType = checkAndExtract(permisoAComprobar);
          if (extractedType) {
            allowedDocTypes.push(extractedType);
          }
        }
      });

      return allowedDocTypes;
    };

    const ensureSignalRConnection = async () => {
      const token = localStorage.getItem('authToken');

      // 1. Si no existe la instancia, la creamos
      if (!connection) {
        connection = new signalR.HubConnectionBuilder()
          .withUrl(`${API_BASE_URL}hubs/FiduGoethe`, {
            accessTokenFactory: () => token
          })
          .withAutomaticReconnect()
          .build();

        // Registramos los listeners una sola vez al crear la conexión
        setupSignalRListeners();
      }

      // 2. Si está desconectado, intentamos conectarlo
      if (connection.state === signalR.HubConnectionState.Disconnected) {
        try {
          await connection.start();
          console.log("✅ Conectado a SignalR con éxito");
        } catch (err) {
          console.error("❌ Error al conectar a SignalR:", err);
          throw new Error("No se pudo establecer la conexión en tiempo real con el servidor.");
        }
      }
    };

    // Separamos los listeners para no duplicarlos si se re-conecta
    const setupSignalRListeners = () => {
      connection.on("FiduGoetheActualizado", (newSpecificSubida) => {
        console.log("----- Event FiduGoetheActualizado received -----");
        try {
          const parsed = typeof newSpecificSubida === 'string' ? JSON.parse(newSpecificSubida) : newSpecificSubida;
          const index = SubidasFidu.value.findIndex(sf => sf.IdSubidasFidu === parsed.IdSubidasFidu);

          if (index !== -1) {
            const existingSubida = SubidasFidu.value[index];
            const updatedSubida = { 
              ...existingSubida, 
              CantDocsSubidos: parsed.CantDocsSubidos, 
              CantErrores: parsed.CantErrores, 
              CantAlertas: parsed.CantAlertas, 
              CantEliminados: parsed.CantEliminados, 
              CantPendientes: parsed.CantPendientes, 
              IdPersonaNavigation: parsed.IdPersonaNavigation, 
              IdSubidasFiduEstadoNavigation: parsed.IdSubidasFiduEstadoNavigation,
              SubidasFiduDetalles: parsed.SubidasFiduDetalles 
            };
            SubidasFidu.value.splice(index, 1, updatedSubida);
            console.log(`✅ Subida ${parsed.IdSubidasFidu} actualizada.`);
          } else {
            SubidasFidu.value.push(parsed);
            console.log(`➕ Nueva subida ${parsed.IdSubidasFidu} agregada.`);
          }

          SubidasFidu.value.sort((a, b) => new Date(b.FechaHoraSubida).getTime() - new Date(a.FechaHoraSubida).getTime());
        } catch (e) {
          console.error("No se pudo parsear el objeto:", e);
        }
        loadingSubmit.value = false;
      });

      connection.onclose(() => {
        console.log("Conexión perdida con SignalR.");
      });
    };


    onBeforeUnmount(() => {
      if (connection) {
        connection.stop();
      }
    });

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();

      // Aseguramos la conexión al montar el componente
      try {
        await ensureSignalRConnection();
      } catch (err) {
        // No bloqueamos el flujo inicial si falla, ya que reintentará en el submit
        console.warn("SignalR no inició en el mount, se reintentará al subir.");
      }

      tipoDocsFromPermissions.value = getDocumentTypesFromPermissions();

      fetchSubidasFidu(1);
    });

    return {
      currentPageSubidas,
      totalPagesSubidas,
      currentPageSubidasDetalle,
      totalPagesSubidasDetalle,
      checkAuth,
      expandedUserId,
      errors,
      documents,
      loadingDocuments,
      loadingSubidas,
      loadingSubidasDetalle,
      loadingSubmit,
      loadingCancelSubmit,
      t,
      deleteDoc,
      deleteDocMasivo,
      isDeleteConfirmVisible,
      isDeleteConfirmVisibleMasivo,
      documentIdToDelete,
      documentNameToDelete,
      documentUserNameToDelete,
      loadingDeleteDocuments,
      hasEliminarDocFidu,
      hasEliminarDocFiduSubidosPorUsuario,
      hasSubirDocFidu,
      hasVerTodasSubidasFidu,
      showModal,
      newSubida,
      submitForm,
      SubidasFidu,
      users,
      tipoDocsFromPermissions,
      fetchSubidasFidu,
      searchTermDetalle,
      filterDetalle,
      fetchDetalle,
      handleScroll,
      verDocumento,
      cancelSubida,
      deQuien,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
.narrow-column {
  flex: 0 0 30px; /* Reduce el tamaño de la columna */
  max-width: 30px; /* Limita el ancho máximo */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}
.modal-container {
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}

.modal-content {
  width: 50%;
  background-color: var(--fondo-secundario);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  z-index: 1002;
}
</style>
